import { clear as dmseClearValue } from "./skyward.ui.distinctMultiSelectEEL.values";
import { resetTemplate } from "./skyward.ui.messagecenter";
import { resize } from "./skyward.ui.responsiveToolbar";
import { Skyward } from "./types";

window.skyward.base.registerScript("applicantTracking", function (skyward: Skyward, $: JQueryStatic)
{
    "use strict";

    // Keep in sync with MetricAction.cs ActionTypes
    enum MetricActionTypes
    {
        Blank = "B",
        ApplyClicked = "A",
        DetailsExpanded = "D",
        FullDetailsViewed = "F"
    }

    // Keep in sync with MetricAction.cs DeviceTypes
    enum MetricDeviceTypes
    {
        Unknown = "U",
        Regular = "R",
        SmallScreen = "S"
    }

    const events =
    {
        load,
        initializeSubmitTab,
        initializeTextAreas,
        deleteAttachmentAndRefresh,
        adjustSubmissionDisclaimerHeight,
        back,
        apply,
        returnToJobBoard,
        previous,
        next,
        resetVerificationEmail,
        resetConfirmationMessage,
        resetReferenceRequestMessage,
        resetPostSubmitQuestionMessage,
        showCopyLink,
        sharePopup,
        favoriteJobPosting,
        scrollToTop,
        copyLink,
        copyJobBoardLink,
        generateStaticJobBoardLink,
        generateFilteredLink,
        resetFilteredLinkFilters,
        saveReferenceInfo,
        submitReferenceInfo,
        initReferenceInfo,
        clearPositionStartDateStored,
        clearPositionStartDateStoredEntry,
        clearEndDateStored,
        clearEndDateStoredWorkflow,
        setupSaveAndMoveToNextPhaseButton,
        saveAndMoveToNextPhase,
        generateFrameworkResizingStyles
    };

    return events;

    function load() { };

    function initializeSubmitTab()
    {
        var submitButton = $("#btnSubmit");
        submitButton.click(function ()
        {
            var applicationID = submitButton.data("applicationid");
            var applicationIDHash = submitButton.data("applicationidhash");
            const container = $("#editApplication");
            const baseErrorContainer = container.find(".currentRecordContentBaseError");
            $.ajax({
                type: "POST",
                url: skyward.global.virtualDir + "ApplicantTracking/Application/ValidateForSubmit/" + applicationID,
                success: function (data)
                {
                    if (data.success !== null)
                    {
                        if (data.success)
                        {
                            skyward.validation.clearValidationMessages(container, baseErrorContainer);

                            submitButton.one("workflowEnd", function (event, data)
                            {
                                if (data.additionalValues.RefreshScreen)
                                {
                                    skyward.changeTracking.overrideGlobalDirtyState(false);
                                }
                            });

                            var windowData =
                            {
                                "Workflow.ApplicationID": applicationID,
                                "Workflow.ApplicationID_securityHash": applicationIDHash
                            };

                            skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', "Create/ApplicantTracking/Application/SubmitApplication", null, windowData, null, null, null, false, null, null, null);
                        }
                        else
                        {
                            skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                        }
                    }
                }
            });
        });

        initializeTextAreas();
    };

    function initializeTextAreas()
    {
        skyward.window.registerLoadDOMCallback(function ()
        {
            $('textarea').each(function () { $(this).height($(this).prop('scrollHeight')); });
        });
    };

    function deleteAttachmentAndRefresh()
    {
        const deleteButtonData = $(this).data();
        const attachmentID = deleteButtonData.attachmentid;
        const action = deleteButtonData.action;

        $.ajax({
            type: "POST",
            url: skyward.global.virtualDir + "ApplicantTracking/Application/" + action + "/" + attachmentID,
            success: function (data)
            {
                if (data.success !== null)
                {
                    if (data.success)
                    {
                        window.location.reload();
                    }
                    else
                    {
                        skyward.validation.displayValidationMessages(data, $("#editApplication"), $("#CurrentRecordContentBaseError"));
                    }
                }
            }
        });
    };

    function adjustSubmissionDisclaimerHeight(element: JQuery<HTMLElement>)
    {
        element[0].style.height = (element[0].scrollHeight) + "px";
    }

    function back()
    {
        window.history.back();
    }

    function apply(this: MouseEvent)
    {
        let applyButton = $(this);
        let applyButtonData = applyButton.data();
        let jobPostingID = applyButtonData.jobpostingid;
        let isSignedIn = applyButtonData.issignedin;
        createAndSaveMetricAction(jobPostingID, MetricActionTypes.ApplyClicked, MetricDeviceTypes.Unknown)

        if (isSignedIn == 'True')
        {
            $.ajax({
                type: "POST",
                dataType: "JSON",
                url: skyward.global.virtualDir + "ApplicantTracking/Application/CanApply",
                data: {
                    id: jobPostingID
                },
                success: function (data)
                {
                    if (data.canApply)
                    {
                        skyward.window.loadContent('full', 'ApplicantTracking', 'Application', 'Apply', jobPostingID);
                    }
                    else
                    {
                        skyward.modalLayer.showErrorDialog("This Job Posting can no longer be applied to.", "Please see the district website for other openings.");
                    }
                }
            });
        }
        else
        {
            //loading the Apply screen as it redirects to the sign in/create account screen
            skyward.window.loadContent('full', 'ApplicantTracking', 'Application', 'Apply', jobPostingID);
        }
    }

    function returnToJobBoard()
    {
        skyward.window.loadContent("full", "ApplicantTracking", "JobBoard", "ViewJobPostings", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    }

    function privateSaveIfNeeded(applicationID, saveAction, destinationTab, dovID)
    {
        if (skyward.changeTracking.isDirty())
        {
            skyward.buttonManager.setClickInProgress(false);
            var settings =
            {
                cmaContainerId: dovID,
                saveButtonSelector: '#' + dovID + '_save'
            };
            skyward.dataobjectviewer.save(dovID, 'ApplicantTracking', 'Application', 'ApplicantDetails', applicationID, 'null', saveAction, false, destinationTab, false, false, null, settings);
        }
        else
        {
            var dataParam = { tab: destinationTab };
            skyward.window.loadContent('full', 'ApplicantTracking', 'Application', 'ApplicantDetails', applicationID, dataParam);
        }
    }

    function previous()
    {
        privateNavigateTab($(this), $('.dataObjectViewer')[0], function (index) { return index - 1 })
    }

    function next()
    {
        privateNavigateTab($(this), $('.dataObjectViewer')[0], function (index) { return index + 1 })
    }

    function privateNavigateTab(button, dataObjectViewer, indexFunc)
    {
        var buttonData = button.data();
        var applicationID = buttonData.applicationid;

        var saveAction;
        var dovID;
        var dataObjectViewerDefined = dataObjectViewer !== undefined;
        if (dataObjectViewerDefined)
        {
            saveAction = dataObjectViewer.getAttribute('data-saveaction');
            dovID = dataObjectViewer.id;
        }

        var tabs = [];
        var currentTabIndex = -1;
        $('.tabListItem').each(function ()
        {
            var tab = $(this)[0];
            tabs.push(tab.id);
            if (tab.classList.contains('current'))
            {
                currentTabIndex = tabs.length - 1;
            }
        });

        var newTabIndex = indexFunc(currentTabIndex);

        if (dataObjectViewerDefined)
        {
            privateSaveIfNeeded(applicationID, saveAction, tabs[newTabIndex], dovID);
        }
        else
        {
            var dataParam = { tab: tabs[newTabIndex] };
            skyward.window.loadContent('full', 'ApplicantTracking', 'Application', 'ApplicantDetails', applicationID, dataParam);
        }
    }

    //Changes here need to be replicated in Skyward.Business.ApplicantTracking.ConfigDistrict as well.
    function resetVerificationEmail(this: HTMLElement)
    {
        resetTemplate(
            this,
            'Verify Your Email Address',
            'Hi {Name.FirstName} {Name.LastName},\n\nPlease click on the link below to verify your email address for Applicant Tracking at {SystemEntity.Name}. This link will be valid for 7 days.\n\nThank You,\nSkyward');
    };

    //Changes here need to be replicated in Skyward.Business.ApplicantTracking.ConfigDistrict as well.
    function resetConfirmationMessage(this: HTMLElement)
    {
        resetTemplate(
            this,
            'Your Application Has Been Successfully Submitted',
            '{PreferredOrLegalFirstName},\n\nYour application for {JobPosting.JobTitle} has been successfully submitted.');
    };

    //Changes here need to be replicated in Skyward.Business.ApplicantTracking.ConfigDistrict as well.
    function resetReferenceRequestMessage(this: HTMLElement)
    {
        resetTemplate(
            this,
            'Reference Request - {Application.PreferredNameFL}',
            '{FullName},\n\n{Application.PreferredNameFL} has listed you as a reference for {Application.JobPosting.JobTitle}. Please click on the link below to complete the reference questionnaire.');
    };

    //Changes here need to be replicated in Skyward.Business.ApplicantTracking.ConfigDistrict as well.
    function resetPostSubmitQuestionMessage(this: HTMLElement)
    {
        resetTemplate(
            this,
            'Application Post Submit Questions',
            '{PreferredNameFL},\n\nPlease click on the link below to complete the additional questions for your {JobPosting.JobTitle} application.');
    };

    function showCopyLink()
    {
        if (navigator.clipboard != undefined) {
            var button = $(this);
            button.removeAttr('style');
        }
    }

    function sharePopup()
    {
        var shareButton = $(this);
        var shareButtonData = shareButton.data();
        var jobPostingID = shareButtonData.jobpostingid;

        showLinkPopup('Job Posting Link', skyward.global.virtualDir + 'ApplicantTracking/JobBoard/GetJobPostingLinkPopup/' + jobPostingID, "", "JobPostingShareModal");
    };

    function showLinkPopup(title: string, action: string, link: string = '', modalId: string = "ApplicantTrackingLinkPopup")
    {
        let buildPopup = function () {
            return $.ajax(action,
                {
                    type: 'POST',
                    dataType: 'HTML',
                    data:
                    {
                        renderType: "contentOnly",
                        link: link
                    }
                });
        };

        skyward.modalLayer.showDialog(title, buildPopup, ['close'], { id: modalId });
    }

    function favoriteJobPosting(this: MouseEvent)
    {
        let favoriteButton = $(this);
        let favoriteButtonData = favoriteButton.data();
        let jobPostingID = favoriteButtonData.jobpostingid;
        let isSignedIn = favoriteButtonData.issignedin == "True";
        let isFavorite = favoriteButtonData.favorite == "True";
        let action = isFavorite ? 'FavoriteJobPostingViewAll' : 'UnfavoriteJobPostingViewAll';

        if (isSignedIn)
        {
            let favoriteSelector = $("#FavoriteButton");
            let unfavoriteSelector = $("#UnfavoriteButton");
            const displayNoneClass = "displayNone";

            favoriteSelector[0].classList.toggle(displayNoneClass);
            unfavoriteSelector[0].classList.toggle(displayNoneClass);
            $.ajax(window.skyward.global.virtualDir + `ApplicantTracking/JobBoard/${action}/${jobPostingID}`,
                {
                    type: 'POST',
                    dataType: 'HTML'
                });
        }
        else
        {
            window.skyward.window.loadContent('full', 'ApplicantTracking', 'JobBoard', action, jobPostingID);
        }
    };

    function scrollToTop()
    {
        $('#JobPostingDetailsContainer')[0].scrollTop = 0;
    };

    function privateCopyElementContentsToClipboard(id: string): void
    {
        let element = document.getElementById(id);
        element.select();
        element.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(element.value);
    }

    function copyLink()
    {
        privateCopyElementContentsToClipboard('linkToCopy');
    }

    function copyJobBoardLink()
    {
        privateCopyElementContentsToClipboard('editConfigSystem_JobBoardLink');
    }

    function generateStaticJobBoardLink(): void
    {
        showLinkPopup('Job Board Link', skyward.global.virtualDir + 'ApplicantTracking/JobBoard/GetStaticJobBoardLinkPopup');
    }

    function generateFilteredLink(): void
    {
        var jobTitle = skyward.controls.getValue($('#editConfigSystem_JobTitle')) as string;

        var getDMSEData = function (id: string): string[]
        {
            var result: string[] = [];
            var element = document.getElementById(id);
            if (element)
            {
                var valueList = JSON.parse(element.firstChild?.value);
                for (var key in valueList) {
                    result.push(valueList[key]);
                }
            }
            return result;
        };

        var jobCategories = getDMSEData('editConfigSystem_JobCategories');
        var jobTypes = getDMSEData('editConfigSystem_JobTypes');
        var locations = getDMSEData('editConfigSystem_Buildings');
        var zipCodes = getDMSEData('editConfigSystem_ZIPCodes');
        var cities = getDMSEData('editConfigSystem_Cities');
        var fullTime = skyward.controls.getValue($('#editConfigSystem_FullTime')) as boolean;
        var partTime = skyward.controls.getValue($('#editConfigSystem_PartTime')) as boolean;

        var url = new URL(skyward.controls.getValue($('#editConfigSystem_JobBoardLink')));

        if (jobTitle)
        {
            url.searchParams.append('JobTitle', jobTitle);
        }
        if (fullTime)
        {
            url.searchParams.append('EmploymentType', 'Full Time');
        }
        if (partTime)
        {
            url.searchParams.append('EmploymentType', 'Part Time');
        }

        /*Parameter keys must stay in sync with JobBoardController.ParameterKeys*/
        var appendDMSEFilterData = function (label: string, collection: string[])
        {
            for (var key in collection)
            {
                url.searchParams.append(label, collection[key]);
            }
        };
        appendDMSEFilterData('JobCategory', jobCategories);
        appendDMSEFilterData('JobType', jobTypes);
        appendDMSEFilterData('Location', locations);
        appendDMSEFilterData('ZIPCode', zipCodes);
        appendDMSEFilterData('City', cities);

        showLinkPopup('Filtered Job Board Link', skyward.global.virtualDir + 'ApplicantTracking/JobBoard/GetFilteredJobBoardLinkPopup', url.href);
    }

    function resetFilteredLinkFilters(): void
    {
        skyward.controls.clearValue($('#editConfigSystem_JobTitle'));
        dmseClearValue($('#editConfigSystem_JobCategories'));
        dmseClearValue($('#editConfigSystem_JobTypes'));
        dmseClearValue($('#editConfigSystem_Buildings'));
        dmseClearValue($('#editConfigSystem_ZIPCodes'));
        dmseClearValue($('#editConfigSystem_Cities'));
        skyward.controls.clearValue($('#editConfigSystem_FullTime'));
        skyward.controls.clearValue($('#editConfigSystem_PartTime'));
        skyward.controls.clearValue($('#editConfigSystem_FilteredLink'));
    }

    function privateSaveReferenceInfo(submit, message, afterFunc, lockOnSuccess)
    {
        skyward.dataobjectviewer.getFieldValues($('#referenceData')).then(fieldValues =>
        {
            $.ajax({
                type: 'POST',
                data: fieldValues,
                url: skyward.global.virtualDir + 'ApplicantTracking/ApplicationReferenceRequest/SaveData?submit=' + submit,
                success: async function (data)
                {
                    if (data.success !== null)
                    {
                        $('#errorCma').toggleClass('cmaHidden', data.success);
                        if (data.success)
                        {
                            if (lockOnSuccess)
                            {
                                $(".js-ApplicantTrackingReferenceInput").attr('disabled', true);
                            }

                            var saveDiv = $('.applicantTrackingSaveDiv');
                            var cma = skyward.contentMessageArea.getContentMessageArea(saveDiv);
                            skyward.validation.clearValidationMessages($('#referenceData'), $('#CurrentRecordContentBaseError'));
                            $('#saveButton').toggleClass('hidden', true);
                            await skyward.changeTracking.clearDirtyList('referenceData');

                            if (cma)
                            {
                                cma.setConfirmationMessage(message);
                                cma.showConfirmation();
                                $('#cma').removeAttr('style');
                                $('.cmaConfirmationMessage').toggleClass('cmaHidden', false);
                            }
                            saveDiv.on('SaveAnimationRedirect', function ()
                            {
                                afterFunc();
                            });
                        }
                        else
                        {
                            skyward.validation.displayValidationMessages(data, $('#referenceData'), $('#CurrentRecordContentBaseError'));
                        }
                    }
                }
            })
        });
    };

    function saveReferenceInfo()
    {
        privateSaveReferenceInfo(false, skyward.contentMessageArea.getDefaultConfirmationMessage(), function ()
        {
            $('.cmaConfirmationMessage').toggleClass('cmaHidden', true);
        }, false);
    };

    function submitReferenceInfo()
    {
        privateSaveReferenceInfo(true, 'The information has been successfully submitted.', function ()
        {
            window.location = skyward.global.virtualDir + 'ApplicantTracking/ApplicationReferenceRequest/ReferenceSubmitted';
        }, true);
    };

    function initReferenceInfo()
    {
        skyward.changeTracking.setUpChangeTracking(this, function ()
        {
            $('#saveButton').toggleClass('hidden', !skyward.changeTracking.isDirty('#referenceData'));
        });
    };

    function privateClearDatePicker(checkboxSelector, dateSelector)
    {
        var checkbox = $(checkboxSelector);
        if (checkbox.val() == 'true')
        {
            var date = $(dateSelector);
            skyward.controls.setValue(date, null, false);
        }
    };

    function clearPositionStartDateStored()
    {
        privateClearDatePicker('#editJobPosting_PositionStartDateIsAsSoonAsPossible', '#PositionStartDateStored');
    };

    function clearPositionStartDateStoredEntry()
    {
        privateClearDatePicker('#editJobPosting_PositionStartDateIsAsSoonAsPossible', '#PositionStartDateStored');
    };

    function clearEndDateStored()
    {
        const type = $(this).data("type");
        privateClearDatePicker('#editJobPosting_Accepting' + type + 'ApplicationsUntilFilled', '#Accepting' + type + 'ApplicationsEndDateStored');
    };

    function clearEndDateStoredWorkflow()
    {
        const type = $(this).data("type");
        privateClearDatePicker('#JobPostingAccepting' + type + 'ApplicationsUntilFilled', '#JobPostingAccepting' + type + 'ApplicationsEndDateStored');
    };

    function setupSaveAndMoveToNextPhaseButton()
    {
        $("#editApplicationTaskUser").on("change", privateUpdateDirtyState);
    }

    function privateUpdateDirtyState()
    {
        $("#SaveAndMoveToNextPhaseButton")[0].style.display = skyward.changeTracking.isDirty() ? "" : "none";
        resize();
    }

    function saveAndMoveToNextPhase()
    {
        var dataObjectViewer = $("#editApplicationTaskUser");
        dataObjectViewer.one("workflowEnd", function (event, data)
        {
            if (data.additionalValues.RefreshScreen)
            {
                skyward.changeTracking.overrideGlobalDirtyState(false);
            }
        });

        skyward.dataobjectviewer.getFieldValues(dataObjectViewer).then(fieldValues =>
        {
            var data = fieldValues;
            var workflowData =
            {
                "Workflow.ApplicationTaskUserID": data["ApplicationTaskUserID"],
                "Workflow.ApplicationTaskUserID_securityHash": data["ApplicationTaskUserIDHash"],
                "Workflow.ApplicationTaskUserIsReviewComplete": data["IsReviewComplete"],
                "Workflow.ApplicationTaskUserNumericRating": data["NumericRating"],
                "Workflow.ApplicationTaskUserPassFailRatingCode": data["PassFailRatingCode"],
                "Workflow.ApplicationTaskTaskStatusCode": data["ApplicationTask.TaskStatusCode"],
                "Workflow.ApplicationTaskCompletedDate": data["ApplicationTask.CompletedDate"],
                "Workflow.ApplicationTaskUserIDCompletedBy": data["ApplicationTask.UserIDCompletedBy"],
                "Workflow.ApplicantTagIDs": data["ApplicantTagIDs"]
            };
            skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', "Create/ApplicantTracking/Application/SaveAndMoveToNextHiringPhase", null, workflowData, null, null, null, false, null, null, null);
        });
    }

    /** Generates styles to resize framework elements to fit on the screen better and give us more screen space */
    function generateFrameworkResizingStyles(this: any): void
    {
        const resizeFramework = () => {
            const skywardBannerDefaultMinWidth = 750;
            const scale = window.outerWidth / skywardBannerDefaultMinWidth;

            const styleTagID = "JobBoardCustomStyles";
            let preexistingStyle = document.getElementById(styleTagID);
            preexistingStyle?.remove();
            if (window.outerWidth >= skywardBannerDefaultMinWidth)
            {
                return;
            }

            // Scales modal popups down to size
            let css = `
            .modalLayer:not(#JobPostingFilters) {
                transform: scale(${scale});
            }`;

            //  Scales the ribbon and navigation menu down to size if needed
            if ($(this).data("scale-framework").toLowerCase() == true.toString().toLowerCase())
            {
                const skywardBannerDefaultHeight = 96;
                const skywardBannerNewHeight = skywardBannerDefaultHeight * scale;

                // Add ribbon and navigation menu to scaling
                css = `.ribbon, .skywardMainMenu__menuPanel, ${css}`;
                css += `
                .ribbon, .skywardMainMenu__menuPanel {
                    transform-origin: top left;
                }`;

                // Resizes the ribbon to it's default min size so everything on it is spaced relatively correctly. Sets the bottom margin to the space gained from resizing so below content can take up the new space
                css += `
                .ribbon {
                    width: ${skywardBannerDefaultMinWidth}px;
                    margin-bottom: ${skywardBannerNewHeight - skywardBannerDefaultHeight}px
                }`;
            }
            // Have to put this static style here because we want to ensure it only applies to the framework on this page and not all of Q
            css += `
                #master, .ribbon, #moduleContent, #detailsPanel {
                    min-width: 0;
                }`;

            const style = document.createElement('style');
            style.id = styleTagID;
            style.appendChild(document.createTextNode(css));
            document.head.appendChild(style);
        }
        window.addEventListener('resize', resizeFramework);
        resizeFramework();
    }

    function createAndSaveMetricAction(jobPostingID: number, actionType: MetricActionTypes, deviceType: MetricDeviceTypes)
    {
        $.ajax({
            url: window.skyward.global.virtualDir + "ApplicantTracking/MetricAction/CreateMetricAction/",
            type: "POST",
            dataType: "viewparthtml",
            data: {
                jobPostingID,
                actionTypeCode: actionType,
                deviceTypeCode: deviceType
            }
        });
    };
});
//# sourceURL=skyward.ui.applicantTracking.ts
